/** Wygenerowany automatycznie przez task writeAppVersionTs */
export const gitVersion = '7de2c1b';
export const brand = 'pzlow';
export const envType = 'fop';
export const buildNumber = '1.6.4';
export const isTestEnv = false;
export const checkVersion = true;

export const version = `${envType}-${buildNumber}@${gitVersion}:${brand}`;
